import React, { useState } from 'react';
import baseStyles from '../InputStyles/inputStyles';
function InstrumentVariedInput({ instrumentType, onChange }) {
  const [inputTwoValue, setInputTwoValue] = useState('');

  const handleInputTwoChange = (e) => {
    const inputValue = e.target.value;
    setInputTwoValue(inputValue);
    onChange(inputValue);
  };
//// console.log'Input varied', instrumentType)
const options = instrumentType === 'Fourier Transform Infrared Spectroscopy' 
? [
    { value: 'Transmission', label: 'Transmission' },
    { value: 'Reflectance', label: 'Reflectance' },
    { value: 'ATR', label: 'ATR' }
  ]
: [
    { value: '532', label: '532 nm' },
    { value: '633', label: '633 nm' },
    { value: '785', label: '785 nm' },
    { value: '1062', label: '1062 nm' }
  ];

return (
    <div style={{...baseStyles.container, maxWidth: '95%'}}>
      <select
        value={inputTwoValue}
        onChange={handleInputTwoChange}
        style={baseStyles.select}
      >
        <option value="">Select {instrumentType === 'Fourier Transform Infrared Spectroscopy' ? 'mode' : 'wavelength'}</option>
        {options.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {inputTwoValue && (
        <div style={baseStyles.selectedValue}>
          {instrumentType === 'Fourier Transform Infrared Spectroscopy' ? 'Mode' : 'Wavelength'}: {inputTwoValue}
        </div>
      )}
    </div>
);
};

export default InstrumentVariedInput;
